import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getHowItWorks } from '../services/howItWorksService';

const HowItWorks = () => {
    const [howItWorksList, setHowItWorksList] = useState([]);
    const [hasFired, setHasFired] = useState(false);
    const sectionRef = useRef(null);
    const location = useLocation();

    // Trigger fetch if visible OR if hash matches this section
    useEffect(() => {
        if (hasFired) return;

        // On normal home load (no hash), fetch immediately instead of waiting for scroll.
        if (!location.hash) {
            setHasFired(true);
            return;
        }

        const targetId = 'our-process';

        // 1. Immediate match for target hash
        if (location.hash === `#${targetId}`) {
            setHasFired(true);
            return;
        }

        let observer = null;
        let timer = null;

        const startObserver = () => {
             observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setHasFired(true);
                        observer.disconnect();
                    }
                },
                { threshold: 0.1, rootMargin: '0px' } 
            );
            if (sectionRef.current) observer.observe(sectionRef.current);
        };

        // 2. Logic: If there is a hash for SOME OTHER section, we delay
        if (location.hash && location.hash !== `#${targetId}`) {
            timer = setTimeout(startObserver, 2000);
        } else {
            startObserver();
        }

        return () => {
            if (timer) clearTimeout(timer);
            if (observer) observer.disconnect();
        };
    }, [hasFired, location.hash]);

    useEffect(() => {
        if (!hasFired) return;

        const fetchData = async () => {
            try {
                const result = await getHowItWorks();
                setHowItWorksList(result || []);
            } catch (error) {
                console.error("Error loading How It Works data", error);
            }
        };
        fetchData();
    }, [hasFired]);

    return (
        <section id="our-process" className="padding bg-black" ref={sectionRef} style={{ minHeight: '500px' }}>
            <div className="container">
                {howItWorksList.length === 0 ? (
                    <div className="text-center whitecolor">
                         <h3>No How It Works data available.</h3>
                    </div>
                ) : (
                    howItWorksList.map((item, index) => (
                        <div key={item.id || index} className="how-it-works-item mb-5">
                            <div className="row">
                                <div className="col-md-12 col-sm-12 text-center">
                                    <div className="heading-title whitecolor wow fadeInUp" data-wow-delay="300ms">
                                        <span>{item.title}</span>
                                        <h2 className="font-normal">{item.name}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-10 offset-md-1">
                                    <div 
                                        className="text-center whitecolor wow fadeIn mt-5" 
                                        data-wow-delay="500ms"
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                    ></div>
                                    <p className="text-center wow fadeIn mt-4" data-wow-delay="500ms">
                                        {item.button_name_1 && (
                                            <Link to={item.button_link_1 || "#"} className="button gradient-btn mb-sm-0 mb-4 mr-sm-3 mr-0">
                                                <span style={{ textTransform: 'lowercase' }}>msb</span> {item.button_name_1.replace(/msb /i, '')}
                                            </Link>
                                        )}
                                        {item.button_name_2 && (
                                            <Link to={item.button_link_2 || "#"} className="button gradient-btn mb-sm-0 mb-4">
                                                <span style={{ textTransform: 'lowercase' }}>msb</span> {item.button_name_2.replace(/msb /i, '')}
                                            </Link>
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </section>
    );
};

export default HowItWorks;
